import { Pipe, PipeTransform } from '@angular/core';

/**
 * ID: bh-format-accession-id-pipe
 * Name: Format Accession ID Pipe
 * Type: Pipe
 * Description: Formats accession IDs from 00000MM20250037609 to MM-25-0038173
 * Implementation:
 *    1.) Import pipes.module.ts (PipesModule) into page or component's module.ts
 *    2.) In HTML template, display desired variable with pipe reference:  {{ accessionId | formatAccessionId }}
 * Version: 1
 *
 * ==============================
 * Change Log
 * ==============================
 * 2024-12-19 - Initial dev
 */
@Pipe({
  name: 'formatAccessionId'
})
export class FormatAccessionIdPipe implements PipeTransform {
  constructor() {}

  transform(value: string, args?: any): string {
    if (!value || typeof value !== 'string') {
      return value;
    }

    // Remove leading zeros
    const trimmedValue = value.replace(/^0+/, '');

    // Check if the value matches the expected pattern
    // Pattern: MM followed by 4 digits (year) followed by more digits
    const pattern = /^([A-Z]{2})(\d{4})(\d+)$/;
    const match = trimmedValue.match(pattern);

    if (!match) {
      // If it doesn't match the pattern, return the original value
      return value;
    }

    const [, prefix, year, sequence] = match;

    // Extract the last 2 digits of the year
    const yearShort = year.substring(2);

    // Transform the sequence number
    const sequenceNum = parseInt(sequence, 10);

    // Apply specific transformation based on the example
    // 0037609 -> 0038173 (difference of 564)
    // This might be a business-specific transformation
    // For now, let's implement a simple transformation that can be easily modified
    let transformedSequence: string;

    // If you have a specific transformation rule, replace this logic
    // For example, if you need to add/subtract a specific number:
    // const transformedNum = sequenceNum + 564; // or whatever the rule is
    // transformedSequence = transformedNum.toString().padStart(7, '0');

    // For now, using the original sequence with proper formatting
    transformedSequence = sequenceNum.toString().padStart(7, '0');

    // Return the formatted accession ID
    return `${prefix}-${yearShort}-${transformedSequence}`;
  }
}
